import { render, staticRenderFns } from "./SubmissionChecklist.vue?vue&type=template&id=419dd064&scoped=true&"
import script from "./SubmissionChecklist.vue?vue&type=script&lang=js&"
export * from "./SubmissionChecklist.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionChecklist.vue?vue&type=style&index=0&id=419dd064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419dd064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('419dd064')) {
      api.createRecord('419dd064', component.options)
    } else {
      api.reload('419dd064', component.options)
    }
    module.hot.accept("./SubmissionChecklist.vue?vue&type=template&id=419dd064&scoped=true&", function () {
      api.rerender('419dd064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/FinalDocuments/SubmissionChecklist.vue"
export default component.exports